'use client';

import { ComponentPropsWithoutRef, useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import Link from 'next/link';
import { buildMinisiteLink } from '../useMinisiteLink';

export type UseAddReviewLinkProps = {
    educatorSlug: string;
    courseSlug?: string;
};

export const useAddReviewLink = ({
    courseSlug,
    educatorSlug,
}: UseAddReviewLinkProps): Pick<
    ComponentPropsWithoutRef<typeof Link>,
    'href' | 'rel' | 'target'
> => {
    const appContext = useContext(AppContext);

    if (courseSlug) {
        switch (appContext.context) {
            case 'marketplace': {
                return {
                    href: `/${educatorSlug}/${courseSlug}/add-review`,
                    rel: 'nofollow',
                };
            }
            case 'minisite': {
                if (appContext.educatorSlug !== educatorSlug) {
                    return {
                        target: '_blank',
                        rel: 'noopener noreferrer nofollow',
                        href: buildMinisiteLink(educatorSlug, `/${courseSlug}/add-review`),
                    };
                }

                return {
                    href: `/${courseSlug}/add-review`,
                    rel: 'nofollow',
                };
            }
            case 'embed': {
                return {
                    target: '_blank',
                    rel: 'nofollow',
                    href: buildMinisiteLink(educatorSlug, `/${courseSlug}/add-review`),
                };
            }
        }
    }

    switch (appContext.context) {
        case 'marketplace': {
            return {
                href: `/${educatorSlug}/reviews/add-review`,
                rel: 'nofollow',
            };
        }
        case 'minisite': {
            if (appContext.educatorSlug !== educatorSlug) {
                return {
                    target: '_blank',
                    rel: 'noopener noreferrer nofollow',
                    href: buildMinisiteLink(educatorSlug, `/reviews/add-review`),
                };
            }
            return {
                href: `/reviews/add-review`,
                rel: 'nofollow',
            };
        }
        case 'embed': {
            return {
                target: '_blank',
                rel: 'nofollow',
                href: buildMinisiteLink(educatorSlug, `/reviews/add-review`),
            };
        }
    }
};
